/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/4
 * @updateTime 2021/11/4
 * @decription 选择案由行为组件入口js
 */
// 表单的布局组件
import acLayoutForm from '@/components/app/layout/form/index.vue';
export default {
    name: 'ac-select-ay-xw',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acLayoutForm
    },
    // 参数
    props: {
        // 案件类型
        ajlx: {
            type: String|Number
        },
        // 年份
        nf: {
            type: Number|String
        },
        // 文本数组
        names: {
            type: Array
        },
        // 代码值
        codes: {
            type: Array
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-select-ay-xw'
            },
            info: {
                checkedFy: this.name,
                checkedFyId: this.code,
                selectAyId: '',
                cId: "",
                gjfyList: [],
                zjfyList: [],
                sjfyList: [],
                sijiAy: [],
            },
            ayListAll: {},
            // 数据列表
            dataList: [],
            // 复选列表
            checkedList: []
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        },
        // 勾选的案由名称
        checkedNames() {
            let _names = [];
            this.checkedList.length && this.checkedList.forEach(checkedItem => {
                _names.push(checkedItem.name);
            });
            return _names.join(';');
        }
    },
    // 创建完成
    created() {
        // 创建完成
        this.init();
    },
    // 方法
    methods: {

        /**
         * 初始化方法
         * */
        init() {
            // 请求案由行为列表数据
            this.getData();
        },

        /**
         * 组装数据
         * @param {Object} data 案由数据
         * @returns {void}
         * */
        assembleData(data) {
            // 案由年份
            const key=(parseInt(this.nf || 2020) >= 2021)? 2021 : 2020;
            // 勾选列表
            const _checkedList = [];
            // 案由行为列表
            this.dataList = data[key][62][0].children.map(item => {
                this.codes.indexOf(item.id) > -1 && _checkedList.push(item);
                item.children.length && item.children.forEach(childItem => {
                    this.codes.indexOf(childItem.id) > -1 && _checkedList.push(childItem);
                })
                return item;
            });
            // 勾选列表
            this.checkedList = _checkedList;
        },

        /**
         * 请求案由数据
         * @returns {void}
         * */
        getData() {
            let ayListAll = sessionStorage.getItem('ayxwListAll');
            if(ayListAll){
                // 组装数据
                this.assembleData(JSON.parse(ayListAll));
            }
            this.$axios.get('ssbq/api/bqsqs/new/ay').then(res => {
                console.log('--res 000', res);
                // 缓存中存储
                sessionStorage.setItem('ayxwListAll', JSON.stringify(res.data));
                // 组装数据
                this.assembleData(res.data);
            })
        },

        // 返回
        back() {
            this.$emit('cancel');
        },

        //点击确定按钮
        eClickSure() {
            // 向上分发确定事件
            this.$emit('confirm', this.checkedList);
        }
    }
};
